"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WebMafCapabilities = (function () {
    function WebMafCapabilities() {
    }
    WebMafCapabilities.prototype.hasLifecycleSuspension = function () {
        return true;
    };
    WebMafCapabilities.prototype.hasNativeParentalPin = function () {
        return false;
    };
    WebMafCapabilities.prototype.hasExternalAppsDisplay = function () {
        return false;
    };
    WebMafCapabilities.prototype.hasVolumeControl = function () {
        return false;
    };
    WebMafCapabilities.prototype.hasExternalAppsLaunch = function () {
        return false;
    };
    return WebMafCapabilities;
}());
exports.WebMafCapabilities = WebMafCapabilities;
